"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extendsAnalyticsEventBase = exports.analyticsEventBase = void 0;
var tslib_1 = require("tslib");
var clientMeta_1 = require("./../../utilities/clientMeta");
var analytics_1 = require("firebase/analytics");
var envConfigBase_1 = require("../../envConfig/envConfigBase");
var logEventExtend = undefined;
var analyticsEventBase = function (_a) {
    var event = _a.event, eventParams = _a.eventParams;
    if (event && !clientMeta_1.clientMeta.isReactSnap && (0, envConfigBase_1.envConfigBase)().appName !== 'Admin') {
        var useEventParams = tslib_1.__assign({ platform: clientMeta_1.clientMeta.platform }, eventParams);
        (0, analytics_1.logEvent)((0, analytics_1.getAnalytics)(), event, useEventParams);
        logEventExtend === null || logEventExtend === void 0 ? void 0 : logEventExtend({ event: event, eventParams: useEventParams });
    }
};
exports.analyticsEventBase = analyticsEventBase;
var extendsAnalyticsEventBase = function (logEvent) {
    logEventExtend = logEvent;
};
exports.extendsAnalyticsEventBase = extendsAnalyticsEventBase;
